import { useEffect } from "react";
import { useState } from "react";
import urls from "../constants";
import { useFetch } from "./useFetch";
import { sleep } from "../utils/processUtils";

export function useSubtitles() {
    const { sendGet } = useFetch();

    const getVideoSubtitles = async (token, videoID) => {
        let attempt = 0;
        while(attempt < 3) {
            try {
                const response = await sendGet(`${urls.GET_VIDEO_SUBTITLES}&videoID=${videoID}`, {
                    AccessToken: token
                });
                const subtitles = processSubtitles(response);
                return subtitles;
            } 
            catch (error) {
                console.error(error);
                console.log(`Attempt ${attempt} to get subtitles for video ${videoID}`);
                await sleep(1000);
                attempt++;
            }
        }
        if(attempt >= 3) {
            return null;
        }
    }   

    const processSubtitles = (subtitles) => {
        //store the subtitles in 10-second blocks so we don't have to iterate through all of them for every second to figure out what to show
        const processedSubtitles = {};
        const languages = Object.keys(subtitles)
        languages.forEach(language => {
            processedSubtitles[language] = {};
            const languageSubtitles = subtitles[language];
            languageSubtitles.forEach(subtitle => {
                const startIndex = getSubtitleTimeIndex(subtitle.Start);
                const endIndex = getSubtitleTimeIndex(subtitle.End);
                for(let currentIndex = startIndex; currentIndex <= endIndex; currentIndex++) {
                    if(!processedSubtitles[language][currentIndex]) {
                        processedSubtitles[language][currentIndex] = [];            
                    }
                    processedSubtitles[language][currentIndex].push(subtitle);
                }
            });
        });
        return processedSubtitles;
    }

    const getSubtitleTimeIndex = function (seconds) {
        return Math.floor(seconds / 10);
    };

    const getCurrentSubtitles = (videoSubtitles, selectedSubtitleLanguages, currentVideoTime) => {
        let currentSubtitles = [];
        selectedSubtitleLanguages.forEach(selectedSubtitleLanguage => {
            if(videoSubtitles[selectedSubtitleLanguage]) {
                const subtitles = videoSubtitles[selectedSubtitleLanguage];
                //we group the subtitles in 10 second blocks so find the correct block (this saves iterating through everything each time)
                const subtitleBlock = subtitles[getSubtitleTimeIndex(currentVideoTime)];
                if(subtitleBlock) {
                    for(let i = 0; i < subtitleBlock.length; i++) {
                        const currentSubtitle = subtitleBlock[i];
                        if(currentVideoTime >= currentSubtitle.Start && currentVideoTime <= currentSubtitle.End) {
                            currentSubtitles.push(currentSubtitle.Text);
                        }
                    }
                }
            }
        });  
        return currentSubtitles;
    }
    
    return { getVideoSubtitles, getCurrentSubtitles };
}